/*
 * Copyright (c) 2018 Integral Agile, Inc. All rights reserved.
 *   Use of this file is subject to the terms and conditions defined in the file
 * 'LICENSE.txt'
 *   which is distributed in the root directory of this source code tree.
 */

import Types from '../constants/actionTypes';

export function toggleMenu({
  classes,
  style,
  result,
  task,
  oldOwnerId,
  element,
  type,
  id,
  props
}) {
  const data = {
    ...props,
    classes,
    style,
    result,
    task,
    oldOwnerId,
    element
  };
  return dispatch =>
    dispatch({
      id,
      newMenu: data,
      menuType: type,
      type: Types.TOGGLE_DROP_DOWN_MENU
    });
}

export function removeMenu(id) {
  return dispatch => dispatch({ id, type: Types.REMOVE_DROP_DOWN_MENU });
}

export function removeAllMenus() {
  return dispatch => dispatch({ type: Types.REMOVE_ALL_DROP_DOWN_MENU });
}
